import getErrorKey from '../../components/address/getErrorKey';

const errorPrefix = 'errors.formFields.maxlength';

const maxLength = (max, fieldName) => (value) => {
  const errorKey = getErrorKey(fieldName, errorPrefix);
  
  return value && value.trim().length > max ? [errorKey, max] : undefined;
};
export default maxLength;
